import React from 'react';
import { Icon } from '@common/components';

export const ExternalLink = ({
  url,
  children,
}: {
  url: string;
  children?: JSX.Element | string;
}) => (
  <>
    <a
      className="wk-external-link text-heavy"
      data-testid="wk-external-link"
      target="_blank"
      rel="noopener noreferrer"
      href={url}
    >
      {children || url}
      <Icon
        className="wk-external-link__icon"
        icon="arrowUpRightFromSquare"
        size="sm"
      />
    </a>
    <style jsx>{`
      .wk-external-link {
        display: inline-block;
      }
      :global(.wk-external-link__icon) {
        margin-left: 4px;
      }
    `}</style>
  </>
);
